import { z } from "zod/v4";

function apiOrigin(value: string): string {
  const parsed = new URL(value);
  if (!(["https:", "http:"].includes(parsed.protocol)) || parsed.username || parsed.password || parsed.pathname !== "/" || parsed.search || parsed.hash || /[\s\\]/.test(value))
    throw new Error("API URL must be an HTTP(S) origin without credentials, a path or query.");
  return parsed.origin;
}
const runtimeConfigSchema = z.strictObject({ environment: z.enum(["staging", "production"]), apiBaseUrl: z.string().url(), analyticsEnabled: z.boolean().optional() })
  .refine((config) => { try { apiOrigin(config.apiBaseUrl); return true; } catch { return false; } }, "API URL must be an HTTP(S) origin.");

/** Container builds require startup configuration; Vite development/static builds use their build input. */
export function resolveApiBaseUrl(runtimeConfig: unknown, runtimeRequired: boolean, buildOrigin: string | undefined): string {
  if (runtimeRequired) {
    const result = runtimeConfigSchema.safeParse(runtimeConfig);
    if (!result.success) throw new Error("Missing or invalid runtime configuration. Set APP_ENV and API_BASE_URL in Dokploy.");
    return apiOrigin(result.data.apiBaseUrl);
  }
  const value = buildOrigin?.trim();
  if (!value) throw new Error("Missing VITE_API_BASE_URL. Set it in .env.local or use a configured build script.");
  return apiOrigin(value);
}
